import React from 'react';
import { ExternalLink, Apple } from 'lucide-react';

// Store download cards (moved here from the retired /download page).
export const HUAWEI_URL = 'https://appgallery.huawei.com/app/C118150847';
export const GOOGLE_URL = 'https://play.google.com/store/apps/details?id=host.emergent.daylight_sync.twa';
const IOS_URL = '/ios';

const qrUrl = (target) =>
  `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(target)}&margin=8&bgcolor=0f172a&color=ffffff`;

const S = {
  en: { title: 'Get Falak', hint: 'Tap a store, or scan the code with another phone\'s camera to share Falak.', download: 'Download', soon: 'Coming soon', live: 'Available' },
  ar: { title: 'حمّل فلك', hint: 'اضغط على المتجر، أو امسح الرمز بكاميرا هاتف آخر لمشاركة فلك.', download: 'حمّل الآن', soon: 'قريباً', live: 'متاح' },
  ur: { title: 'فلک ڈاؤن لوڈ کریں', hint: 'اسٹور پر ٹیپ کریں، یا فلک شیئر کرنے کے لیے کسی دوسرے فون کے کیمرے سے کوڈ اسکین کریں۔', download: 'ڈاؤن لوڈ کریں', soon: 'جلد آرہا ہے', live: 'دستیاب' },
  zh: { title: '获取 Falak', hint: '点击商店，或用另一部手机的相机扫描二维码来分享 Falak。', download: '立即下载', soon: '即将推出', live: '已上线' },
  fa: { title: 'دریافت فلک', hint: 'روی فروشگاه بزنید، یا برای اشتراک‌گذاری فلک، کد را با دوربین گوشی دیگری اسکن کنید.', download: 'دانلود', soon: 'به‌زودی', live: 'در دسترس' },
  tr: { title: 'Falak\'ı İndir', hint: 'Bir mağazaya dokunun veya Falak\'ı paylaşmak için kodu başka bir telefonun kamerasıyla tarayın.', download: 'İndir', soon: 'Yakında', live: 'Mevcut' },
  fr: { title: 'Obtenir Falak', hint: 'Touchez une boutique, ou scannez le code avec l\'appareil photo d\'un autre téléphone pour partager Falak.', download: 'Télécharger', soon: 'Bientôt', live: 'Disponible' },
  bn: { title: 'ফলক ডাউনলোড করুন', hint: 'একটি স্টোরে ট্যাপ করুন, অথবা ফলক শেয়ার করতে অন্য ফোনের ক্যামেরা দিয়ে কোডটি স্ক্যান করুন।', download: 'ডাউনলোড', soon: 'শীঘ্রই আসছে', live: 'উপলব্ধ' },
  id: { title: 'Dapatkan Falak', hint: 'Ketuk toko, atau pindai kode dengan kamera ponsel lain untuk membagikan Falak.', download: 'Unduh', soon: 'Segera hadir', live: 'Tersedia' },
  es: { title: 'Obtén Falak', hint: 'Toca una tienda o escanea el código con la cámara de otro teléfono para compartir Falak.', download: 'Descargar', soon: 'Próximamente', live: 'Disponible' },
  pt: { title: 'Obtenha o Falak', hint: 'Toque numa loja ou escaneie o código com a câmera de outro celular para compartilhar o Falak.', download: 'Baixar', soon: 'Em breve', live: 'Disponível' },
  de: { title: 'Falak herunterladen', hint: 'Tippe auf einen Store oder scanne den Code mit der Kamera eines anderen Handys, um Falak zu teilen.', download: 'Herunterladen', soon: 'Demnächst', live: 'Verfügbar' },
  it: { title: 'Scarica Falak', hint: 'Tocca uno store, oppure scansiona il codice con la fotocamera di un altro telefono per condividere Falak.', download: 'Scarica', soon: 'Prossimamente', live: 'Disponibile' },
};

const openStore = (url) => {
  if (url.startsWith('http')) window.open(url, '_blank', 'noopener,noreferrer');
  else window.location.href = url;
};

const StoreCard = ({ id, name, url, hue, t, live, icon }) => (
  <button
    type="button"
    onClick={() => openStore(url)}
    className="rounded-2xl p-4 border relative text-start w-full transition-transform hover:-translate-y-0.5"
    style={{ background: `linear-gradient(145deg, ${hue}14 0%, rgba(255,255,255,0.03) 100%)`, borderColor: `${hue}59` }}
    data-testid={`store-btn-${id}`}
  >
    {live && (
      <span
        className="absolute top-3 end-3 text-[11px] font-semibold px-2 py-0.5 rounded-full"
        style={{ background: 'rgba(16,185,129,0.18)', color: '#34D399', border: '1px solid rgba(52,211,153,0.35)' }}
      >
        ● {t.live}
      </span>
    )}
    <div className="text-lg font-bold mb-3 flex items-center gap-2" style={{ color: '#F1F5F9', paddingInlineEnd: live ? 72 : 0 }}>
      {icon}<span dir="ltr">{name}</span>
    </div>
    {live ? (
      <img src={qrUrl(url)} alt={`${name} QR`} width={110} height={110} className="rounded-lg border mb-3" style={{ borderColor: 'rgba(255,255,255,0.12)' }} data-testid={`qr-${id}`} />
    ) : (
      <div className="rounded-lg border flex items-center justify-center mb-3 text-xs" style={{ width: 110, height: 110, borderColor: 'rgba(255,255,255,0.1)', color: '#94A3B8' }}>
        {t.soon}
      </div>
    )}
    {live && (
      <div className="text-sm flex items-center gap-1.5 font-medium" style={{ color: hue }}>
        {t.download}
        <ExternalLink size={12} />
      </div>
    )}
  </button>
);

export const StoreDownloadSection = ({ lang }) => {
  const t = S[lang] || S.en;
  return (
    <section style={{ marginTop: 40 }} data-testid="about-store-section">
      <h2 style={{ fontSize: 20, fontWeight: 700, color: '#FFFFFF', margin: '0 0 8px' }}>{t.title}</h2>
      <p style={{ fontSize: 14, lineHeight: 1.7, color: '#CBD5E1', margin: '0 0 16px' }}>{t.hint}</p>
      <div className="grid sm:grid-cols-3 gap-3">
        <StoreCard id="huawei" name="Huawei AppGallery" url={HUAWEI_URL} hue="#F59E0B" t={t} live />
        <StoreCard id="googleplay" name="Google Play" url={GOOGLE_URL} hue="#34D399" t={t} live />
        <StoreCard id="ios" name="App Store" url={IOS_URL} hue="#7DD3FC" t={t} icon={<Apple size={18} />} />
      </div>
    </section>
  );
};
